import '@formatjs/intl-listformat/polyfill';
import '@formatjs/intl-listformat/locale-data/en';

export function formatHomeType(
    isAuction: string | string[],
    isRetirementHome: string | string[],
    isSharedOwnership: string | string[],
    newHomes: string | string[]
) {
    const homeTypes = {
        isAuction,
        newHomes,
        isRetirementHome,
        isSharedOwnership
    };

    const homeTypeOptions: { [key: string]: string } = {
        isAuction: 'auction',
        newHomes: 'new homes',
        isRetirementHome: 'retirement homes',
        isSharedOwnership: 'shared ownership'
    };

    const only: string[] = [];
    const exclude: string[] = [];
    const include: string[] = [];

    Object.entries(homeTypes).forEach(([key, value]) => {
        switch (value) {
            case 'true':
            case 'only':
                only.push(homeTypeOptions[key]);
                break;
            case 'false':
            case 'exclude':
                exclude.push(homeTypeOptions[key]);
                break;
            default:
                include.push(homeTypeOptions[key]);
                break;
        }
    });

    const formatter = new Intl.ListFormat('en-GB', {
        style: 'long',
        type: 'conjunction'
    });

    return [
        only.length > 0 ? `Show only ${formatter.format(only)}` : '',
        exclude.length > 0 ? `Exclude ${formatter.format(exclude)}` : '',
        include.length > 0 ? `Include ${formatter.format(include)}` : ''
    ];
}
